import { render, staticRenderFns } from "./TableSearchDocument..vue?vue&type=template&id=201e4f53&"
import script from "./TableSearchDocument..vue?vue&type=script&lang=ts&"
export * from "./TableSearchDocument..vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports